/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomofftitle3Inputs */

const en_liveroomofftitle3 = /** @type {(inputs: Liveroomofftitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room is off`)
};

const de_liveroomofftitle3 = /** @type {(inputs: Liveroomofftitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room ist aus`)
};

/**
* | output |
* | --- |
* | "Live Room is off" |
*
* @param {Liveroomofftitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomofftitle3 = /** @type {((inputs?: Liveroomofftitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomofftitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomofftitle3(inputs)
	return de_liveroomofftitle3(inputs)
});
export { liveroomofftitle3 as "liveRoomOffTitle" }